import { Flex } from "Element/Flex";
import React from "react";
import { StyledHeroText } from "../styled";
import { InventoryWrapper } from "./styled";
import DogeCarousel from "Component/DogeCarousel";

const Inventory = () => {
  return (
    <InventoryWrapper>
      <Flex justifyContent="center" mb={24}>
        <StyledHeroText>Your Doge</StyledHeroText>
      </Flex>
      <DogeCarousel show={5} scroll={5} />
    </InventoryWrapper>
  );
};

export default Inventory;
